import { useState, useCallback } from "react";
import { apiService } from "../services/apiClient";
import { apiUrl } from "../services/apiUrl";

export const useAnalytics = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const fetchAnalytics = useCallback(async (filters = {}) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.get(apiUrl.aipdAnalytics(filters));
      setData(response.data);
      return response.data;
    } catch (err) {
      const msg = err.response?.data?.message || err.message;
      setError(msg);
      console.error("Error fetching analytics:", msg);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    data,
    // Convenience accessors
    kpis:      data?.kpis      || {},
    filters:   data?.filters   || { reports: [], personas: [], users: [] },
    charts:    data?.charts    || { byGroup: {}, byDate: { dates: [], views: [] } },
    tables:    data?.tables    || { topReports: [], topVisuals: [], userActivity: [] },
    fetchAnalytics,
  };
};
